import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@github-ui/react-router'

export interface CommentIdentityProps {
  /** The login of the comment author. */
  login: string
  /** When true, render a link to the author's profile with a hovercard; otherwise render plain text. */
  linkable: boolean
  /** Whether the author is an agent (e.g. Copilot). */
  isAgent?: boolean
}

/**
 * Renders a comment author's identity. When `linkable` is true it links to the
 * author's profile with a user hovercard; otherwise it renders the name as plain
 * text (used for the ghost user, bots, agents, and the current viewer).
 */
export function CommentIdentity({login, linkable, isAgent = false}: CommentIdentityProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  if (!linkable) {
    return (
      <span>
        <ProfileReference login={login} isAgent={isAgent} />
      </span>
    )
  }

  return (
    <Link to={`/${login}`} className="color-fg-default text-bold" {...getHovercardAttributesForType('user', {login})}>
      <ProfileReference login={login} isAgent={isAgent} />
    </Link>
  )
}
